type FormLabelProps = {
    labelFor: string;
    labelName: string;
};

export default function FormLabel({ labelFor, labelName }: FormLabelProps) {
    return (
        <label htmlFor={labelFor} className="block text-sm font-medium leading-6 text-foreground">
            {labelName}
        </label>
    );
}
